'use strict';

function service($http, $q, $location, $window) {
    return function (command, socket, params, time) {
        let model = this;
        model.socket = socket;
        model.command = command;
        model.p = angular.copy($location.$$search); // we dont want to overwrite the existing $location
        // add params if they are presented
        if (typeof params === 'object') {
            for (let i in params) {
                model.p[i] = params[i];
            }
        }
        // if time
        if (typeof time === 'object') {
            model.p.start = time.start;
            model.p.end = time.end;
        }
        if (typeof model.p.type !== 'undefined') {
            model.type = model.p.type;
        }
        if (typeof model.p.reqId !== 'undefined') {
            model.reqId = model.p.reqId;
        }
        model.defer = $q.defer();
        model.socket.emit(model.command, model.p)
        model.socket.on(model.command, function (data) {
            if ((typeof data.reqId !== 'undefined') && (typeof model.reqId !== 'undefined')) {
                if (model.reqId !== data.reqId) {
                    return;
                }
            }
            if (data === 'done') {
                model.socket.removeListener(model.command);
                if (typeof model.type !== 'undefined') {
                    model.defer.resolve(model.type);
                } else {
                    model.defer.resolve();
                }
                delete model.defer;
                return;
            }
            // else if (data.error === 'error') {
            //     model.socket.removeListener(model.command);
            //     if (data.code === 4608) {
            //         model.defer.reject(); // if a timeout error
            //     } else {
            //         model.defer.resolve();
            //     }
            //     delete model.defer;
            //     return;
            // }
            else {
                model.defer.notify(data);
            }
        })
        return model.defer.promise;
    }
}

service.$inject = ['$http', '$q', '$location', '$window'];
module.exports = service;


/** WEBPACK FOOTER **
 ** ./src/pages/services/fetchstream.js
 **/